module.exports = __webpack_public_path__ + "img/景田宏浩分校@2x.76612749.png";